import { render, staticRenderFns } from "./Mapping.vue?vue&type=template&id=479e5884"
import script from "./Mapping.vue?vue&type=script&lang=ts"
export * from "./Mapping.vue?vue&type=script&lang=ts"
var disposed = false

function injectStyles (context) {
  if (disposed) return
  var style0 = require("./Mapping.vue?vue&type=style&index=0&id=479e5884&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/actions-runner/_work/mfe-intelligent-match/mfe-intelligent-match/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('479e5884')) {
      api.createRecord('479e5884', component.options)
    } else {
      api.reload('479e5884', component.options)
    }
    module.hot.accept("./Mapping.vue?vue&type=template&id=479e5884", function () {
      api.rerender('479e5884', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Mapping.vue"
export default component.exports